// Add your custom JS here.

/* Chiude il sottomenu quando clicco su un altra voce di menu */

document.addEventListener("DOMContentLoaded", function() {
    let dropdownItems = document.querySelectorAll(".dropdown");

    // Chiudi il dropdown quando si fa clic altrove nel documento
    document.addEventListener("click", function(event) {
        if (!event.target.closest(".dropdown")) {
            dropdownItems.forEach(function(item) {
                let dropdownMenu = item.querySelector(".dropdown-menu");
                dropdownMenu.classList.remove("show");
            });
        }
    });

    dropdownItems.forEach(function(item) {
        let dropdownToggle = item.querySelector(".dropdown-toggle");
        let dropdownMenu = item.querySelector(".dropdown-menu");

        dropdownToggle.addEventListener("click", function(event) {
            let isOpen = dropdownMenu.classList.contains("show");

            // Chiudi tutti gli altri dropdown aperti
            dropdownItems.forEach(function(otherItem) {
                let otherDropdownMenu = otherItem.querySelector(".dropdown-menu");
                if (otherDropdownMenu !== dropdownMenu) {
                    otherDropdownMenu.classList.remove("show");
                }
            });

            if (!isOpen) {
                dropdownMenu.classList.add("show");
            }

            event.stopPropagation();
        });
    });
});

